const parseValue = (key, value) => {
  try {
    return JSON.parse(value)
  } catch (error) {
    // Ignore and move on.
  }

  return null
}

export const save = (key, value) => window.localStorage.setItem(key, JSON.stringify(value))

export const retrieve = key => parseValue(window.localStorage.getItem(key))
